import { render, staticRenderFns } from "./MobileBoxControls.vue?vue&type=template&id=40b7ec50&scoped=true"
import script from "./MobileBoxControls.js?vue&type=script&lang=js&external"
export * from "./MobileBoxControls.js?vue&type=script&lang=js&external"
import style0 from "./MobileBoxControls.scss?vue&type=style&index=0&id=40b7ec50&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b7ec50",
  null
  
)

export default component.exports